import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

import { PeopleStepsOneWrapper } from '../People/PeopleSteps/PeopleStepsOne/styled';
import { ResourcesStepsOneWrapper } from '../Resources/ResourcesSteps/ResourcesStepsOne/styled';

export const BD100Wrapper = styled.div`
  width: 100%;
  min-height: 100svh;

  padding-top: var(--navbar-height);

  background: #fdfafa;

  ${BREAKPOINTS.tablet} {
    padding-top: 0px;
  }
`;

export const BD100Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px;

  ${PeopleStepsOneWrapper}, ${ResourcesStepsOneWrapper} {
    min-height: unset;
  }

  .spinner-icon {
    ${infiniteRotationAnimation('5s', 'ease')}
  }
`;
